import { CircularProgress } from '@mui/material';
import React from 'react';

export interface SpinnerProps {
  size?: number;
  textColor?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({
  size = 30,
  textColor = 'text-tertiary',
}) => {
  return (
    <div
      className="text-gray-600 font-sans flex justify-center"
      data-testid="spinner"
    >
      <CircularProgress className={textColor} color="inherit" size={size} />
    </div>
  );
};
